export default {
  xs: 375,
  sm: 710,
  md: 930,
  lg: 1440,
};
